import PropTypes from "prop-types";
import * as React from "react";
import { Button, Spinner, WarningIcon } from "../../themeV2";
import css from "./ShopImagesEditor.module.css";

export default function PendingTile({ item, onRetry, onDiscard }) {
  const isFailed = item.status === "failed";

  return (
    <li aria-label={item.fileName} aria-busy={!isFailed} className={css.tile}>
      <img
        className={css.tileImage}
        src={item.dataUrl}
        alt=""
        width={150}
        height={200}
      />
      {isFailed ? (
        <div className={css.pendingError}>
          <p className={css.pendingMessage}>
            <WarningIcon aria-hidden="true" className={css.inlineIcon} />
            {item.error}
          </p>
          <div className={css.pendingActions}>
            <Button
              variant="tonal"
              size="sm"
              onClick={() => onRetry(item.id)}
              aria-label={`Retry ${item.fileName}`}
            >
              Retry
            </Button>
            <Button
              variant="text"
              size="sm"
              onClick={() => onDiscard(item.id)}
              aria-label={`Discard ${item.fileName}`}
            >
              Discard
            </Button>
          </div>
        </div>
      ) : (
        <div className={css.pendingProgress}>
          <Spinner />
          <span className={css.tileName}>Uploading…</span>
        </div>
      )}
    </li>
  );
}

PendingTile.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    fileName: PropTypes.string.isRequired,
    dataUrl: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    error: PropTypes.string,
  }).isRequired,
  onRetry: PropTypes.func.isRequired,
  onDiscard: PropTypes.func.isRequired,
};
